import { SceneDataProps } from '@/types/sceneProps'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface ScenesProps {
  scenes: SceneDataProps[]
}

const initialState: ScenesProps = {
  scenes: [],
}

const scenesSlice = createSlice({
  name: 'scenes',
  initialState,
  reducers: {
    handleSetScenes(state, action: PayloadAction<ScenesProps>) {
      state.scenes = action.payload.scenes
    },
  },
})

export const { handleSetScenes } = scenesSlice.actions

export default scenesSlice.reducer
